/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TakenInputs */

const en_taken = /** @type {(inputs: TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken`)
};

const id_taken = /** @type {(inputs: TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diambil`)
};

/** @type {(inputs: TakenInputs) => LocalizedString} */
const es_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const fr_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const de_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const ja_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const zh_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const ar_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const it_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const ru_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const pt_taken = en_taken;

/** @type {(inputs: TakenInputs) => LocalizedString} */
const ko_taken = en_taken;

/**
* | output |
* | --- |
* | "Taken" |
*
* @param {TakenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const taken = /** @type {((inputs?: TakenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TakenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_taken(inputs)
	if (locale === "es") return es_taken(inputs)
	if (locale === "fr") return fr_taken(inputs)
	if (locale === "de") return de_taken(inputs)
	if (locale === "ja") return ja_taken(inputs)
	if (locale === "zh") return zh_taken(inputs)
	if (locale === "ar") return ar_taken(inputs)
	if (locale === "id") return id_taken(inputs)
	if (locale === "it") return it_taken(inputs)
	if (locale === "ru") return ru_taken(inputs)
	if (locale === "pt") return pt_taken(inputs)
	return ko_taken(inputs)
});